import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';

const state = () => {
  return {
    playlist: [],
    selectedVideo: [],
  };
};

// actions
const actions = {
  async fetchPlaylist({ commit }, playlistId, fetcher = dataFetch) {
    // reset playlist
    state.playlist = [];
    const endpoint = `${API_END_POINTS.VIDEO_PLAYLIST}${playlistId}`;
    const res = await fetcher(endpoint);
    const playlist = res.data.playlist;
    commit('SET_PLAYLIST', playlist);
  },

  async fetchVideo({ state, commit }, videoId, fetcher = dataFetch) {
    // reset selected video
    state.selectedVideo = [];
    const endpoint = `${API_END_POINTS.VIDEO}${videoId}`;
    const res = await fetcher(endpoint);
    const selectVid = res.data.video;
    selectVid.relatedVideos = selectVid.relatedVideos.slice(0, 3);
    commit('SET_SELECTED_VIDEO', selectVid);
  },
};

// mutations
const mutations = {
  SET_PLAYLIST: (state, playlist) => {
    state.playlist = playlist;
  },
  SET_SELECTED_VIDEO: (state, video) => {
    state.selectedVideo = video;
  },
};

// getters
const getters = {
  getVideoPlaylist: state => {
    return state.playlist;
  },
  getVideoDetails: state => {
    return state.selectedVideo;
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
};
